// extracted by mini-css-extract-plugin
module.exports = {"confirmBtn":"styles-module__confirmBtn___Qb7ep","total":"styles-module__total___2vGPf"};